<div class="font-md text-muted outlet-address mb-3">
  <div>{{ outlet.address }}</div>
  <div>{{ outlet.postNumber }} {{ outlet.cityName }}</div>
  @if (outlet.phone) {
    <div>{{ outlet.phone }}</div>
  }
</div>

@if (scheduleType === OUTLET_SCHEDULE_TYPES.PICKUP_SCHEDULE) {
  <div class="font-xs fw-bold mb-1"
       [translate]="'common.delivery.pickupTimes'">
    Pickup times
  </div>
}

@for (days of formattedSchedule; track $index) {
  @if (!days.isClosed) {
    <div class="d-flex justify-content-between font-md">
      <div>{{ days.days }}</div>

      <div>{{ days.begin + ' - ' + days.end }}</div>
    </div>
  }
}

@if (openingTime.length > 0) {
  <div class="mt-3 font-md">
    <div>
      {{ 'orderProcess.delivery.deliveryForms.openingTimes' | translate }}:
    </div>

    @for (item of openingTime; track $index) {
      <div class="d-flex justify-content-between">
        <div>{{ item.dateRange }}</div>

        <div>
          @if (item.isClosed) {
            <span [translate]="'common.dayOff'">
              Closed
            </span>
          } @else {
            {{ item.time }}
          }
        </div>
      </div>
    }
  </div>
}


@if (outlet.text && !options?.hideOutletText) {
  <div class="accordion-outlet-free-field font-md mt-3"
       [innerHTML]="outlet.text"></div>
}

@if ((showNext || options?.nextText) && !hideNextButton) {
  <div class="mt-3">
    <button class="btn btn-pink w-100"
            (click)="onNext.emit(outlet)">{{ nextText || options?.nextText }}
    </button>
  </div>
}

@if (!options?.hideMap) {
  <div class="accordion-outlet-single-map d-md-none">
    <ui-accordion-outlet-map
      [outlet]="outlet"
    ></ui-accordion-outlet-map>
  </div>
}
